import { render } from "./section-contact.vue?vue&type=template&id=20afc36c"
import script from "./section-contact.vue?vue&type=script&lang=js"
export * from "./section-contact.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__